<div id="il-made-app" class="my-1">
    <search-box
        :searchQuery="searchQuery"
        @update:searchQuery="searchQuery = $event"
        :layoutType="layoutType"
        @update:layoutType="layoutType = $event"
        :isIllinoisMade="true"
    />

    <filter-popup
        :categoriesFacets="categoriesFacets"
        :selectedCategory="selectedCategory"
        @update:selectedCategory="selectedCategory = $event"
        :selectedRegion="selectedRegion"
        :regionsFacets="regionsFacets"
        @update:selectedRegion="selectedRegion = $event"
        :clearFilters="clearFilters"
        :totalResults="totalResults"
    />

    <filter-header
        :categoriesFacets="categoriesFacets"
        :selectedCategory="selectedCategory"
        @update:selectedCategory="selectedCategory = $event"
    />

    <results-count
        v-if="!isLoading"
        :results="results"
        :totalResults="totalResults"
        :searchQuery="searchQuery"
        :selectedCategory="selectedCategory"
        :selectedRegion="selectedRegion"
        :clearFilters="clearFilters"
        :layoutType="layoutType"
    />

    <grid-view
        v-if="layoutType === 'grid'"
        :results="results"
        :isLoading="isLoading"
        :categoriesFacets="categoriesFacets"
        @update:selectedCategory="selectedCategory = $event"
    />

    <list-view
        v-if="layoutType === 'list'"
        :results="results"
        :groupedItems="groupedItems"
        :selectedCategory="selectedCategory"
        :regionFilters="regionFilters"
        :selectedRegion="selectedRegion"
        @update:selectedRegion="selectedRegion = $event"
        :isLoading="isLoading"
    />

    <pagination
        v-if="!isLoading"
        :currentPage="currentPage"
        :totalPages="totalPages"
        @update:currentPage="currentPage = $event"
    />
</div>
